"use strict";
exports.__esModule = true;
exports.toInt = exports.toFloat = void 0;
var toFloat = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0.0; }
    if (value === null || value === undefined) {
        return defaultValue;
    }
    var result = parseFloat(value);
    return isNaN(result) ? defaultValue : result;
};
exports.toFloat = toFloat;
var toInt = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    if (value === null || value === undefined) {
        return defaultValue;
    }
    var result = parseInt(value);
    return isNaN(result) ? defaultValue : result;
};
exports.toInt = toInt;
//# sourceMappingURL=number.js.map